import UploadPublicCertificate from './UploadPublicCertificate';
import type { UploadPublicCertificateProps } from './types';

export default UploadPublicCertificate;
export type { UploadPublicCertificateProps };
